/**
 * Utilidades para validación y formato de números de teléfono internacionales
 */

/**
 * Limpia un número de teléfono removiendo espacios, guiones y paréntesis
 * @param {string} phone - Número de teléfono a limpiar
 * @returns {string} - Número limpio
 */
export const cleanPhoneNumber = (phone) => {
  return phone.replace(/[\s\-()]/g, '');
};

/**
 * Valida si un número de teléfono tiene formato internacional válido
 * @param {string} phone - Número de teléfono a validar
 * @returns {boolean} - true si es válido, false si no
 */
export const isValidInternationalPhone = (phone) => {
  const cleanPhone = cleanPhoneNumber(phone);
  const internationalPhoneRegex = /^\+\d{1,4}\d{4,15}$/;
  return internationalPhoneRegex.test(cleanPhone);
};

/**
 * Obtiene ejemplos de números de teléfono por país
 * @returns {Array} - Array de objetos con ejemplos
 */
export const getPhoneExamples = () => [
  { country: 'USA', code: '+1', example: '+1 5551234567' },
  { country: 'UK', code: '+44', example: '+44 7911123456' },
  { country: 'Brazil', code: '+55', example: '+55 11999999999' },
  { country: 'Spain', code: '+34', example: '+34 612345678' },
  { country: 'Germany', code: '+49', example: '+49 15123456789' },
  { country: 'France', code: '+33', example: '+33 612345678' },
  { country: 'Italy', code: '+39', example: '+39 3123456789' },
  { country: 'Indonesia', code: '+62', example: '+62 81234567890' },
  { country: 'Mexico', code: '+52', example: '+52 5512345678' },
  { country: 'Argentina', code: '+54', example: '+54 91123456789' }
];

/**
 * Formatea un número de teléfono para mostrar
 * @param {string} phone - Número de teléfono
 * @returns {string} - Número formateado
 */
export const formatPhoneDisplay = (phone) => {
  const cleanPhone = cleanPhoneNumber(phone);
  if (cleanPhone.startsWith('+')) {
    return cleanPhone;
  }
  return '+' + cleanPhone;
};